import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "./pages/HomePage";
import RegistrationPage from "./pages/RegistrationPage";
import RazorpayPaymentPage from "./pages/RazorpayPaymentPage";
import OptionsPage from "./pages/OptionsPage";
import ExamDetailPage from "./pages/ExamDetailPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/register/payment" element={<RazorpayPaymentPage />} />
          <Route path="/options" element={<OptionsPage />} />
          <Route path="/exam/:examId" element={<ExamDetailPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
